<template>
    <DCard padding>
        <CForm @submit.prevent="submitForm">
            <DFormRow
                :label="$t('certificates.search_label_ids')"
                :error="errors.id"
            >
                <DInput
                    v-model="form.id"
                    :placeholder="$t('certificates.search_placeholder_ids')"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificates.search_label_domains')"
                :error="errors.domain"
            >
                <DInput
                    v-model="form.domain"
                    :placeholder="$t('certificates.search_placeholder_domains')"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificates.status_label')"
                :error="errors.status"
            >
                <DSelect
                    v-model="form.status_option"
                    :options="statusOptions"
                    :placeholder="$t('certificates.status_label')"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificates.search_label_autorenewal')"
                :error="errors.autoRenewal"
            >
                <DSelect
                    v-model="form.auto_renewal"
                    :options="autoRenewalOptions"
                    :placeholder="$t('certificates.search_label_autorenewal')"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificates.type_label')"
                :error="errors.type"
            >
                <DSelect
                    v-model="form.type"
                    :options="typeOptions"
                    :placeholder="$t('certificates.type_label')"
                />
            </DFormRow>
            <DFormRow
                :label="$t('certificates.search_label_expiry')"
                :error="errors.expiry"
            >
                <DSelect
                    v-model="form.expiry"
                    :options="expiryOptions"
                    :placeholder="$t('certificates.search_label_expiry')"
                />
            </DFormRow>

            <DFabs>
                <DFab
                    id="btn-search"
                    icon="magnify"
                    :label="$t('certificates.search_button')"
                    @click="submitForm"
                />
                <DFab
                    icon="close"
                    color="secondary"
                    @click="back"
                />
            </DFabs>
        </CForm>
    </DCard>
</template>

<script>

import { router, useForm } from '@inertiajs/vue3'
import { CForm } from '@coreui/vue-pro'

const defaultFieldList = {
    id: null,
    domain: null,
    status_option: null,
    auto_renewal: null,
    type: null,
    expiry: null
}
export default {
    name: 'SearchCertificateForm',
    components: { CForm },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        statusOptions: {
            type: Array,
            default: () => { return [] }
        },
        expiryOptions: {
            type: Array,
            default: () => { return [] }
        },
        autoRenewalOptions: {
            type: Array,
            default: () => { return [] }
        },
        typeOptions: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            form: useForm(Object.assign({}, defaultFieldList))
        }
    },
    methods: {
        submitForm () {
            const searchFields = {}
            for (const field in defaultFieldList) {
                if (this.form[field] !== null && this.form[field] !== []) {
                    searchFields[field] = this.form[field]
                }
            }
            router.get(this.$route('certificates.advanced-search.show', searchFields))
        },
        back () {
            router.get(this.$route('certificates.index'))
        }
    }
}
</script>

<style scoped>

</style>
